import { type FC } from 'react';

import { SelectionsExportMenuPanel } from '@/features/selectionsPanel/exportMenu/selectionsExportMenuPanel';
import { useSelectionsPanelContext } from '@/features/selectionsPanel/selectionsPanelProvider';

import { SelectionsCardsPanel } from './selectionsCardPanel';

export const SelectionsPanel: FC = () => {
  const { isExportMenuOpen } = useSelectionsPanelContext();

  return isExportMenuOpen ? (
    <SelectionsExportMenuPanel />
  ) : (
    <SelectionsCardsPanel />
  );
};
